export default __webpack_public_path__ + "static/media/slide_tap_huan_2022.f93ad8c0.png";